import logo from "./img/logo2x-1.png";
function Footer() {
  return (
    <>
      <footer className="flex flex-col h-[40vh] my-[70px] justify-evenly items-center ">
        <img className="h-[10rem]" src={logo} alt="logo" />
        <p className="text-center gold text-[1.4rem] w-[30%]">
          Life is a cake and love is the icing in top of it. Without love, it
          becomes difficult to swollow life.
        </p>
        <div className="text-white ">
          <i className="bg-[#aa8453] p-[10px] px-[15px]  mx-[10px] fab fa-facebook-f"></i>
          <i className="bg-[#aa8453] p-[10px] px-[15px]  mx-[10px] fab fa-instagram"></i>
        </div>
      </footer>
      <div className="w-[100%] gold flex justify-center items-center h-[10vh] border-t-slate-200 border-t-[1px]">
        <p className="text-[1.2rem]">Copyright @ Qode Interactive</p>
      </div>
    </>
  );
}
export { Footer };
